<template>
  <base-join-challenge
    button-title="קדימה"
    :on-click="openUpdateGoal"
  >
    <template v-slot:info-by-challenge-type>
      <icon-line
        icon-name="track_changes"
        text="יעד אישי"
      />
    </template>
  </base-join-challenge>
</template>

<script lang="ts" setup>

import BaseJoinChallenge from './BaseJoinChallenge.vue';
import IconLine from '../ChallengeInfo/IconLine/IconLine.vue';
import useUpdatePersonalGoalModal from '../../composables/useUpdatePersonalGoalModal';
import { ACTION } from '../UpdatePersonalGoalModal/consts';

const { openUpdatePersonalGoalModal } = useUpdatePersonalGoalModal();

function openUpdateGoal() {
  openUpdatePersonalGoalModal(ACTION.CREATE);
}

</script>
